import React from "react";
import { ArrowRight, Truck } from "lucide-react";
import { groupTags } from "../mock";

export default function GroupOrdersSection() {
  const details = [
    { label: "How many shirts?", value: "1  ·  30  ·  50  ·  100  ·  Custom" },
    { label: "Colors", value: "Choose one or several — mixing colors doesn't change your price." },
    { label: "Sizes", value: "S through 3XL, in any breakdown you need." },
    { label: "Design", value: "Upload yours, or have us create it for you." },
    { label: "Date needed", value: "Tell us the deadline and we'll work back from it." },
  ];
  return (
    <section id="group" className="bg-[color:var(--dms-cream-2)] py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14">
        <div>
          <p className="kicker">Group t-shirts</p>
          <h2 className="font-serif text-4xl md:text-5xl text-[color:var(--dms-navy)] mt-4 leading-tight">Need 12, 30, 50 or 100+ shirts?</h2>
          <div className="w-14 h-[2px] bg-[color:var(--dms-peach)] mt-5" />
          <p className="mt-6 text-[color:var(--dms-navy)]/70 leading-relaxed">
            Ordering shirts for your church, birthday, business, family, team, or special event? Tell us what you need and we’ll calculate a custom price for you.
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            {groupTags.map((t) => (
              <span key={t} className="px-3 py-1 rounded-full border border-[color:var(--dms-navy)]/15 text-[color:var(--dms-navy)] text-xs">{t}</span>
            ))}
          </div>
          <div className="mt-8">
            <a href="#group" className="btn-navy">Request a group quote <ArrowRight className="w-4 h-4" /></a>
          </div>
          <div className="mt-6 flex items-center gap-2 text-[color:var(--dms-navy)]/60 text-sm">
            <Truck className="w-4 h-4" /> No minimum  ·  Free shipping over $50.00
          </div>
        </div>
        <div className="bg-white border border-[color:var(--dms-navy)]/10 rounded-2xl p-8">
          <h3 className="font-serif text-2xl text-[color:var(--dms-navy)]">What we'll ask you</h3>
          <div className="mt-6 divide-y divide-[color:var(--dms-navy)]/10">
            {details.map((d) => (
              <div key={d.label} className="py-4">
                <p className="text-[11px] tracking-widest uppercase text-[color:var(--dms-peach)] font-semibold">{d.label}</p>
                <p className="text-[color:var(--dms-navy)]/80 mt-1 text-sm">{d.value}</p>
              </div>
            ))}
          </div>
          <p className="mt-4 text-xs text-[color:var(--dms-navy)]/60 leading-relaxed">
            There's no minimum — order one shirt or a thousand. Spend $50 or more and shipping is on us. This is a quote request only — you will not be charged now. We review your details and send you the exact price before anything is printed.
          </p>
        </div>
      </div>
    </section>
  );
}
